import axios, { type AxiosRequestConfig } from 'axios';
import axiosRetry from 'axios-retry';

import {
  DEPLOYMENT_TIER,
  INTEGRATIONS_BACKEND_HOST,
  JWT_COOKIE_NAME,
  PACKAGE_NAME,
  VERSION,
} from '@/configuration/client';
import isBrowser from '@/helpers/isBrowser';
import { getCookiesAsJson } from '@/providers/Auth';

import axiosRetryCondition from '../axiosRetryCondition';

if (!INTEGRATIONS_BACKEND_HOST) {
  throw new Error('INTEGRATIONS_BACKEND_HOST not defined');
}

const client = axios.create({
  baseURL: INTEGRATIONS_BACKEND_HOST,
  timeout: 60 * 1000 * 20, // 10 minutes
});

client.interceptors.request.use(
  (config): AxiosRequestConfig => {
    if (isBrowser()) {
      const token = getCookiesAsJson()[JWT_COOKIE_NAME] || window.httpToken;
      if (!config.headers) {
        config.headers = {};
      }
      if (token) {
        config.headers.Authorization = token;
      }
      config.headers['x-noodle-client-version'] = `${DEPLOYMENT_TIER}@${PACKAGE_NAME}@${VERSION}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosRetry(client, {
  retryCondition: axiosRetryCondition,
});

export default client;
